export function initializeTrackingScripts() {
    // Google tracking script: Always load with minimal tracking
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-J5FFCE3VT1';
    gtagScript.async = true;
    
    // Add load event listener to ensure gtag is available
    // gtagScript.onload = () => {
    //     console.log('✅ Google Analytics script loaded');
    // };
    
    // gtagScript.onerror = () => {
    //     console.error('❌ Failed to load Google Analytics script');
    // };
    
    document.head.appendChild(gtagScript);

    const gtagInlineScript = document.createElement('script');
    gtagInlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        
        // Minimal tracking before consent
        gtag('consent', 'default', {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
        });
        
        // Basic configuration (e.g., page views)
        gtag('config', 'G-J5FFCE3VT1', { 'anonymize_ip': true });
        
        // Signal that gtag is ready
        window.gtagReady = true;
        //console.log('✅ gtag function initialized');
    `;
    document.head.appendChild(gtagInlineScript);

    // Meta Pixel: Always load basic pixel, respect consent for advanced events
    const pixelId = window.META_PIXEL_ID;
    if (pixelId) {
        const fbInline = document.createElement('script');
        fbInline.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);\n            t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}\n            (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');\n            fbq('init', '${pixelId}'); fbq('track', 'PageView');`;
        document.head.appendChild(fbInline);
    }

    // Fire queued Meta event from server (if any) — regardless of consent
    try {
        const eventRaw = document.head.querySelector('meta[name="meta-event"]')?.getAttribute('content');
        if (eventRaw && typeof fbq === 'function') {
            const evt = JSON.parse(eventRaw);
            if (typeof evt === 'string') {
                fbq('track', evt);
            } else if (evt && evt.name) {
                fbq('track', evt.name, evt.params || {});
            }
        }
    } catch (e) {
        console.warn('Meta event meta parsing failed', e);
    }

    // Optional: If consent accepted, expand Google and load LinkedIn
    if (localStorage.getItem('cookie_consent') === 'accepted') {
        const gtagConsentScript = document.createElement('script');
        gtagConsentScript.innerHTML = `
            gtag('consent', 'update', {
                ad_storage: 'granted',
                analytics_storage: 'granted'
            });
            gtag('config', 'G-J5FFCE3VT1');
        `;
        document.head.appendChild(gtagConsentScript);

        const liScript = document.createElement('script');
        liScript.src = '/js/tracking-li.js';
        liScript.async = true;
        
        liScript.onload = () => {
        //    console.log('✅ LinkedIn tracking script loaded');
            window.lintrkReady = true;
        };
        
        liScript.onerror = () => {
        //    console.error('❌ Failed to load LinkedIn tracking script');
        };
        
        document.head.appendChild(liScript);
    }
}
